import {Box, Typography} from '@mui/material';
import ArrWidgetWrapper from '../../../components/common/arr-widget-wrapper/ArrWidgetWrapper';

const WidgetWrapperDemo: React.FC = () => {
  return (
    <Box className="demo-page modal-demo">
      <ArrWidgetWrapper
        title="Users in Active Projects"
        showInfo
        showSettings
        showReplace
        onSettingsClick={() => alert('Settings clicked')}
        onReplaceClick={() => alert('Close clicked')}
      >
        <Typography>Active Users: 0</Typography>
        <Typography>Total Users: 0</Typography>
      </ArrWidgetWrapper>
    </Box>
  );
};

export default WidgetWrapperDemo;
